// Check whether an element is inside a matching parent.
function hasParentWithMatchingSelector(target, selector) {
  if (!(target instanceof Element)) return false;

  const matchingParent = target.closest(selector);
  return Boolean(matchingParent && matchingParent !== target);
}

document.addEventListener('click', function (e) {
  const target = e.target instanceof Element ? e.target : null;
  if (!target) return;

  // Prevent level-2 mega-menu labels from acting as links.
  if (target.classList.contains('mega-menu__link--level-2')) {
    e.preventDefault();
  }

  const isMenuDrawerLink = target.classList.contains('menu-drawer__menu-item-link');
  const isInsideParentMenu = hasParentWithMatchingSelector(target, '.has-children');
  const isInsideSubmenu = hasParentWithMatchingSelector(target, '.menu-drawer__submenu');

  // Toggle parent mobile-menu items without scanning the whole document.
  if (isInsideParentMenu && isMenuDrawerLink && !isInsideSubmenu) {
    const detailsElement = target.closest('details');
    if (!detailsElement) return;

    e.preventDefault();
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      if (isOpen) {
        detailsElement.removeAttribute('open');
      } else {
        detailsElement.setAttribute('open', '');
      }
    }, 100);
  }
});

// Facet navigation exists only on collection pages that have facet_nav configured.
const slidesContainer = document.getElementById('facet-container');
const slide = document.querySelector('#facet-container .facet');
const prevButton = document.getElementById('slide-arrow-prev');
const nextButton = document.getElementById('slide-arrow-next');

if (slidesContainer && slide && prevButton && nextButton) {
  nextButton.addEventListener('click', () => {
    slidesContainer.scrollLeft += slide.clientWidth;
  });

  prevButton.addEventListener('click', () => {
    slidesContainer.scrollLeft -= slide.clientWidth;
  });
}
